/**
 * 同意管理 (CMP) タグの読み込み。
 *
 * CMP が適用する CSP の接続許可リストは本番ドメインのみのため、dev / staging では
 * バックエンド API への接続がブロックされる。本番ビルドのみ読み込むよう
 * cmpEnabled (lib/env.ts) でガードする。
 */
import { cmpEnabled } from "@/lib/env";

if (cmpEnabled) {
  const script = document.createElement("script");
  script.src = "https://cmp.datasign.co/v2/582c3405ea/cmp.js";
  script.async = true;
  document.head.appendChild(script);
}
